import { getConfig } from '../configs/config';
/**
 * resolvePageId
 *
 * helper for resolving page id
 *
 * @param {String} pageIdStr
 * @param {Boolean} isLoggedIn
 */
const resolvePagePath = (pageIdStr: string) => {
  const { basePagePath = '', analyticsDataObject } = getConfig();
  const activePagePath = analyticsDataObject?.activePagePath || '';

  const regex = /^\/\//g;
  const checkValidStr = (str: string) => (str ? `/${str}` : '');

  // If pageIdStr is provided, set it into the analyticsDataObject as activePagePath
  if (pageIdStr) {
    analyticsDataObject.activePagePath = pageIdStr;
  }

  // Use the provided pageIdStr if available, otherwise use the activePagePath
  const resolvedPath = pageIdStr || activePagePath;

  // Construct the final path
  const pathValues = [basePagePath, resolvedPath];
  return pathValues
    .map((item) =>
      item ? checkValidStr(item).replace(regex, '/').replace('_', '-') : ''
    )
    .join('');
};

export default resolvePagePath;
